import React from "react";
import img from "../../assets/images/Landing/images/web.svg";
import img2 from "../../assets/images/Landing/images/app.svg";
import img3 from "../../assets/images/Landing/images/hosting.svg";
import img4 from "../../assets/images/Landing/images/consultation.svg";
import styles from "./MainServices.module.css";

const MainServices = () => {
  return (
    <div id="services" className={styles.servicesSection}>
      <section>
        <div className={styles.titleSection}>
          <h2 className={styles.servicesTitle}>Pro Services</h2>
          <div className={styles.titleUnderline}></div>
          <h2 className={styles.servicesSubtitle}>
            Empowering Real Estate Professionals to Grow and Succeed
          </h2>
        </div>

        <div className={styles.servicesGrid}>
          <div className={styles.serviceCard}>
            <img
              alt="Property Listings Management"
              className={styles.serviceImage}
              src={img}
            />
            <h2 className={styles.serviceHeading}>
              Property Listings Management
            </h2>
            <p className={styles.serviceText}>
              Manage your property listings with ease using our intuitive
              platform. Get real-time updates, receive analytical reports, and
              publish visually engaging content to stand out from the
              competition.
            </p>
          </div>

          <div className={styles.serviceCard}>
            <img
              alt="Client Engagement Tools"
              className={styles.serviceImage}
              src={img2}
            />
            <h2 className={styles.serviceHeading}>Client Engagement Tools</h2>
            <p className={styles.serviceText}>
              Engage potential buyers and renters through our platform with
              high-impact visual content, personalized communication, and
              automated responses.
            </p>
          </div>

          <div className={styles.serviceCard}>
            <img
              alt="Brand Building"
              className={styles.serviceImage}
              src={img3}
            />
            <h2 className={styles.serviceHeading}>Brand Building</h2>
            <p className={styles.serviceText}>
              Grow your personal brand with the help of our platform's built-in
              tools, from AI-driven blogs to social media integrations that keep
              your audience engaged.
            </p>
          </div>

          <div className={styles.serviceCard}>
            <img
              alt="Market Analytics & AI Insights"
              className={styles.serviceImage}
              src={img4}
            />
            <h2 className={styles.serviceHeading}>
              Market Analytics & AI Insights
            </h2>
            <p className={styles.serviceText}>
              Leverage advanced market analytics and AI insights to better
              understand buyer behavior, forecast market trends, and make
              data-driven decisions to close more deals faster.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.collaborationSection}>
        <div className={styles.collaborationWrapper}>
          <div className={styles.collaborationContent}>
            <h3 className={styles.collaborationHeading}>
              We <span className={styles.collaborationHighlight}>Build</span>
            </h3>
            <p className={styles.collaborationText}>
              We build Pro AI Realtor to serve as a powerful listing optimizer
              and intelligent chatbot, meticulously trained on real estate laws.
              Our platform enhances lead generation and automates marketing
              processes, enabling professionals to make well-informed decisions.
            </p>
          </div>

          <div className={styles.collaborationContent}>
            <h3 className={styles.collaborationHeading}>
              We{" "}
              <span className={styles.collaborationHighlight}>Collaborate</span>
            </h3>
            <p className={styles.collaborationText}>
              We collaborate with leading organizations to curate a
              comprehensive portfolio of properties, streamlining the search
              process and providing real estate professionals with a unified
              platform for efficient listing management.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MainServices;
